
import React from 'react';
import { Anchor, Box } from 'grommet';

const ShowInMapLink = ({setMapPoints, points}) => {
    const onClick = () => {
        setMapPoints(points);
    }

    return (
        <Box pad={{top: '18px'}} direction="row">
            <Anchor
                href={`#/map`}
                label="Zobrazit v mapě"
                onClick={onClick}
            />
        </Box>
    );
}

export default ShowInMapLink;
